export const profile = {
  name: "Tasnia Anower Medha",
  firstName: "Tasnia",
  role: "Full-Stack Engineer",
  location: "Dhaka, Bangladesh",
  headline:
    "Full-stack engineer specializing in the MERN stack, mobile app delivery, and QA-driven release quality, with 2+ years shipping production applications.",
  phone: "+880 1712 888233",
  phoneHref: "tel:+8801712888233",
  emails: [
    {
      label: "University",
      value: "tasniaanower@iut-dhaka.edu",
    },
    {
      label: "Personal",
      value: "tasniaanwer@gmail.com",
    },
  ],
  links: {
    github: "https://github.com/tasniaanwer",
    githubLabel: "github.com/tasniaanwer",
    linkedin: "https://www.linkedin.com/in/tasnia-anwer-172a28283/",
    linkedinLabel: "tasnia-anwer",
    resume: "/resume.pdf",
    resumeName: "Tasnia_Anower_Medha_CV.pdf",
  },
  current: {
    role: "QA Engineer",
    company: "Kaizennext",
  },
};

export const about = {
  paragraphs: [
    "I design, build, and release production software across web and mobile, then stay close to quality through testing and deployment. That mix of delivery and QA is how I keep releases predictable.",
    "Most recently I have been testing the Uttirno mobile app and a psychometric platform at Kaizennext. Before that I shipped the Qpon app, its website, order system, and admin dashboard at Hungry Tiger, and maintained ChatChef for a Canadian client.",
    "I am completing a B.Sc. in Software Engineering at Islamic University of Technology. Outside client work I have built telemedicine, disaster-relief, and pet-adoption products, including a championship win at IUT Coderush 3.0.",
  ],
  stats: [
    { value: "2+", label: "Years shipping production software" },
    { value: "4", label: "Roles across product and QA" },
    { value: "4", label: "Live products I have worked on" },
  ],
};

export const experience = [
  {
    company: "Kaizennext",
    role: "QA Engineer",
    period: "Sep 2026 — Present",
    location: "Dhaka, Bangladesh",
    points: [
      "Execute functional, regression, and usability test cases across the Uttirno mobile app and the Psychometric web platform, logging defects and verifying fixes before release.",
      "Work directly with the development team to reproduce, prioritize, and confirm that reported issues are resolved before each release cycle.",
    ],
  },
  {
    company: "Hungry Tiger",
    role: "Software Developer",
    period: "Mar 2026 — Sep 2026",
    location: "Dhaka, Bangladesh",
    points: [
      "Built and shipped the Qpon mobile app end to end, now live on Google Play, along with its companion website, order management system, and admin dashboard.",
      "Maintained ChatChef, a production website for a Canadian client, fixing bugs and shipping feature updates on a recurring release schedule.",
    ],
  },
  {
    company: "Battery Low Interactive",
    role: "Web Developer Intern",
    period: "Oct 2025 — Feb 2026",
    location: "Dhaka, Bangladesh",
    points: [
      {
        text: "Built and tested features for Shobdo Mukur, a live web application, across development and QA.",
        link: { href: "https://shobdomukur.com/", label: "shobdomukur.com" },
      },
      {
        text: "Developed and tested a government-facing web application to the reliability standards required for public-sector deployment.",
        link: { href: "https://pwd-dms.com/", label: "pwd-dms.com" },
      },
    ],
  },
  {
    company: "Mellowhost",
    role: "Web Developer Intern",
    period: "Oct 2025",
    location: "Remote",
    points: [
      "Completed a one-month internship focused on ERP development and web performance optimization.",
    ],
  },
];

export const projects = [
  {
    title: "Whiskers-n-Co",
    kicker: "Pet adoption platform",
    year: "2025",
    award: "Champion, IUT Coderush 3.0",
    description:
      "A MERN platform with AI-powered pet-breed recognition, real-time chat between adopters and shelters, and automated adoption-status tracking.",
    stack: ["MERN", "Node.js", "Express.js", "MongoDB"],
    image: "/images/whisker-n-co.png",
    github: "https://github.com/nazifatasneem13/whiskersnco",
    live: "https://wnco.onrender.com/",
  },
  {
    title: "Ashroy-e",
    kicker: "Blockchain disaster relief",
    year: "2024",
    award: "Best Project, IUT Coderush 3.0 Showcase",
    description:
      "A decentralized relief platform with Solidity smart contracts on Ethereum Sepolia, so donations and campaigns stay transparent and tamper-proof.",
    stack: ["MERN", "Ethereum", "Hardhat", "Web3.js", "Sepolia"],
    image: "/images/Screenshot 2025-03-19 011731.png",
    github: "https://github.com/tauhid-taaha/blockchain-crowdfunding",
  },
  {
    title: "DaktarShab",
    kicker: "Telemedicine platform",
    year: "2025",
    description:
      "A privacy-focused telemedicine product with real-time WebRTC consultations, Prisma and PostgreSQL scheduling, and role-based access for patients and doctors.",
    stack: ["Next.js", "Prisma", "Neon", "WebRTC", "Tailwind"],
    image: "/images/Screenshot 2025-11-02 173408.png",
    live: "https://docschedule.vercel.app/",
  },
  {
    title: "Ay Bay",
    kicker: "Personal finance app",
    year: "2026",
    description:
      "A cross-platform finance tracker for income, expenses, loans, and installment schedules, built from a shared TypeScript codebase for web and mobile.",
    stack: ["React Native", "TypeScript"],
    github: "https://github.com/tasniaanwer/Ay-Bay",
  },
];

export const skillGroups = [
  {
    title: "Languages",
    items: ["JavaScript", "Python", "Java", "C++", "C", "HTML", "CSS"],
  },
  {
    title: "Frameworks",
    items: ["React", "Next.js", "Node.js", "Express.js", ".NET"],
  },
  {
    title: "Data",
    items: ["MongoDB", "PostgreSQL", "Neon", "Neo4j", "Oracle"],
  },
  {
    title: "Delivery",
    items: ["AWS", "Microsoft Azure", "Vercel", "Render", "GitHub", "Postman", "JUnit"],
  },
  {
    title: "Practice",
    items: [
      "Testing & QA",
      "OOP",
      "DSA",
      "Software architecture",
      "Design patterns",
      "Web & mobile delivery",
    ],
  },
];

export const education = [
  {
    school: "Islamic University of Technology",
    credential: "B.Sc. in Software Engineering",
    period: "2022 — 2026",
    location: "Gazipur, Bangladesh",
  },
  {
    school: "Govt. M. M. City College, Khulna",
    credential: "Higher Secondary Certificate, Science",
    detail: "GPA 5.00",
    period: "2019 — 2021",
    location: "Khulna, Bangladesh",
  },
];

export const achievements = [
  {
    title: "Finalist",
    detail: "BioNet",
    event: "Blockchain Olympiad Bangladesh",
  },
  {
    title: "Top 10 finalist",
    detail: "Car Selling System",
    event: "DevOps Hackathon, IUT National ICT Fest 2024",
  },
  {
    title: "Project contributor",
    detail: "PhysixLab",
    event: "HackCSB 2024",
  },
];
